theme.headerMainMenuModule = (function () {
  function mainMenu(e) {
    let headerWrapper = e.querySelector(".header_bottom");
    let menuLiSelector = document.querySelectorAll(".header__menu_li");
    menuLiSelector.forEach((item) => {
      let timer;
      if (item.classList.contains("menu__item_has_children")) {
        let menuItemUrl = "",
            menuItemLocation = "";
        item.addEventListener("mouseenter", (event) => {
          timer = setTimeout(function() {
            let listDetails = item.querySelector("details");
            listDetails.setAttribute("open", "");
            item.querySelector("summary").setAttribute("aria-expanded", true);
            listDetails.classList.add("menu-open-transition");
            const menuElement = listDetails.querySelector(".header-nav--menu");
            menuElement.style.transition = "all 4s ease-in 4s";
          }, 100); 
        });
        item.addEventListener("mouseleave", (event) => {
          clearTimeout(timer);
            let listDetails = item.querySelector("details");
            listDetails.removeAttribute("open");
            listDetails.classList.remove("menu-open-transition");
            const menuElement = listDetails.querySelector(".header-nav--menu");
            menuElement.style.transition = "all 0s ease 0s";
            item.querySelector("summary").setAttribute("aria-expanded", false);
        })
        item.querySelector("summary").addEventListener("click", (event) => {
          event.stopPropagation();
          menuItemUrl = item.querySelector("summary").dataset.href;
          menuItemLocation = `${window.location.origin}${menuItemUrl}`;
          let itemAttr = item.querySelector("details");
          if (itemAttr.hasAttribute("open")) {
            location.href = `${menuItemLocation}`;
          }
        });
      }
    });
  }
  return mainMenu;
})();
